import styled from "styled-components";

export const ImgOnly = styled.img`
  width: 100%;
  height: auto;
  @media screen and (min-width: 1020px) {
    width: 50%;
    height: auto;
  }
`;
